export const MismoDocumentType = {
  DEFAULT: 'Default',
  UCD: 'Ucd',
};
